import React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

interface SystemMessageCardProps {
  text?: string;
}

const SystemMessageCard = ({ text }: SystemMessageCardProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        textAlign: "center",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Typography
        sx={{
          fontSize: "0.85rem",
          color: "#ffffff",
          fontStyle: "italic",
          opacity: 0.8,
        }}
      >
        {text || ""}
      </Typography>
    </Box>
  );
};

export default SystemMessageCard;
